import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["width"];
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { key: 1 };
import { computed, onBeforeMount, ref } from 'vue';
import { I18nInfo } from '@/user/models';
import store from '@/user/store';
import { Badge, Pagination, TextButton } from '@/user/components/common';
import moment from 'moment';
import { AccountService } from '@/user/apis/account/account.api';
import useFramedView from '@/user/components/FramedView';
const PAGE_SIZE = 5;
const DATE_FORMAT = 'YYYY.MM.DD';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LectureCompleted',
    setup(__props) {
        useFramedView();
        const t = new I18nInfo('eduCenter.account');
        const t_common = new I18nInfo('common');
        const style = {
            section1: 'rounded-12 mt-16 flex gap-20 bg-gray-100 p-24 w-full',
            listWrap: 'w-full',
            listItem: 'whitespace-pre-wrap relative pl-16 before:content-["•"] before:absolute before:left-0 before:text-gray-800 text-gray-800 text-body-4',
            section2: 'mt-24 overflow-hidden rounded-12 border border-gray-250',
            table: 'w-full border-collapse',
            thWrapper: 'bg-gray-150',
            th: 'px-24 py-17 border-r-1 last:border-r-0 border-gray-250 text-body-3 text-gray-850',
            td: 'px-24 py-17 text-body-5 text-gray-700 border-t-1 border-r-1 last:border-r-0 border-gray-200',
            tdTitleWrapper: 'flex flex-col gap-6 cursor-pointer group',
            tdTitle: 'text-title-4 text-gray-900 line-clamp-2 group-hover:text-blue-700',
            withIcon: {
                wrapper: 'text-caption-1 flex items-center gap-4 group-hover:text-blue-700',
                wrapperCenter: 'text-caption-1 flex items-center gap-4 justify-center',
                icon1: 'text-gray-400 size-16 group-hover:text-blue-700',
                icon2: 'text-gray-600 size-20',
                iconRed: 'text-red-700 size-16',
                iconBlue: 'text-blue-700 size-16',
            },
            tdButtonWrapper: 'flex flex-col gap-8 items-start',
            textCenter: 'text-center',
            tdSupport: 'flex items-center gap-4',
            paginationWrapper: 'mt-24 flex justify-center',
            statusWrapper: 'flex items-center justify-center',
            endWrapper: 'flex items-center justify-center',
            noItem: 'flex items-center justify-center py-20 desktop:py-23',
            noItemDsc: 'text-body-4 text-gray-700',
        };
        const currentPage = ref(1);
        const maxPage = computed(() => store.getters['AccountStore/completedLectures']?.totalPages || 1);
        const headers = [
            {
                width: '630',
                text: t.translate('table.title'),
                className: 'text-left',
            },
            {
                width: '130',
                text: t.translate('table.completedDate'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.educationState'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.completedState'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.materialFile'),
                className: 'text-center',
            },
            {
                width: '130',
                text: t.translate('table.certificate'),
                className: 'text-center',
            },
        ];
        const contents = computed(() => store.getters['AccountStore/completedLectures']?.content || []);
        onBeforeMount(async () => {
            await fetch();
        });
        async function fetch() {
            await store.dispatch('AccountStore/getCompletedLectures', {
                page: currentPage.value - 1,
                size: PAGE_SIZE,
            });
        }
        async function changePage(newPage) {
            currentPage.value = newPage;
            await fetch();
        }
        async function getMaterialFile(lectureId, attenderId) {
            await AccountService.getMaterialFile({ lectureId, attenderId });
        }
        async function getCertificate(lectureId, attenderId) {
            await AccountService.getCertificate({ lectureId, attenderId });
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("section", {
                    class: _normalizeClass(style.section2)
                }, [
                    _createElementVNode("table", {
                        class: _normalizeClass(style.table)
                    }, [
                        _createElementVNode("colgroup", null, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header) => {
                                return _createElementVNode("col", {
                                    key: header.text,
                                    width: header.width
                                }, null, 8, _hoisted_1);
                            }), 64))
                        ]),
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", {
                                class: _normalizeClass(style.thWrapper)
                            }, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headers, (header) => {
                                    return _createElementVNode("th", {
                                        key: header.text,
                                        class: _normalizeClass([style.th, header.className])
                                    }, _toDisplayString(header.text), 3);
                                }), 64))
                            ], 2)
                        ]),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contents.value, (item, index) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    key: `lecture-${currentPage.value}-${index}-${item.id}`,
                                    class: "first:[&>td]:border-t-0"
                                }, [
                                    _createElementVNode("td", {
                                        class: _normalizeClass(style.td)
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(style.tdTitleWrapper)
                                        }, [
                                            _createVNode(_component_router_link, {
                                                to: { path: `/attend/detail/${item.lectureId}` },
                                                class: _normalizeClass([style.tdTitle])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(item.title), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["to", "class"])
                                        ], 2)
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, _toDisplayString(item.isFinished ? _unref(moment)(item.finishedAt).format(DATE_FORMAT) : '-'), 3),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, _toDisplayString(item.getProgressState()), 3),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass([style.withIcon.wrapperCenter])
                                        }, [
                                            (item.isFinished)
                                                ? (_openBlock(), _createBlock(_unref(Badge), {
                                                    key: 0,
                                                    color: item.isCompleted ? 'blue' : 'gray',
                                                    type: "outlined"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.getResultState()), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["color"]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_2, "-"))
                                        ], 2)
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, [
                                        (item.isCompleted && item.materialFileExists)
                                            ? (_openBlock(), _createBlock(_unref(TextButton), {
                                                key: 0,
                                                onClick: ($event) => (getMaterialFile(item.lectureId, item.attenderId)),
                                                "class-name": "shrink-0",
                                                color: "blue",
                                                "desktop-size": "medium",
                                                "mobile-size": "medium",
                                                "icon-class-name": "size-16",
                                                "icon-name": "download",
                                                "icon-position": "left"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.download')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["onClick"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_3, "-"))
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass([style.td, style.textCenter])
                                    }, [
                                        (item.isCompleted)
                                            ? (_openBlock(), _createBlock(_unref(TextButton), {
                                                key: 0,
                                                onClick: ($event) => (getCertificate(item.lectureId, item.attenderId)),
                                                "class-name": "shrink-0",
                                                color: "blue",
                                                "desktop-size": "medium",
                                                "mobile-size": "medium",
                                                "icon-class-name": "size-16",
                                                "icon-name": "download",
                                                "icon-position": "left"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_unref(t_common).translate('button.download')), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["onClick"]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_4, "-"))
                                    ], 2)
                                ]));
                            }), 128))
                        ])
                    ], 2),
                    (contents.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(style.noItem)
                        }, [
                            _createElementVNode("p", {
                                class: _normalizeClass(style.noItemDsc)
                            }, _toDisplayString(_unref(t).translate('noData')), 3)
                        ], 2))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("nav", {
                    class: _normalizeClass(style.paginationWrapper)
                }, [
                    _createVNode(_unref(Pagination), {
                        class: "!text-title-4",
                        page: currentPage.value,
                        "total-pages": maxPage.value,
                        "onUpdate:page": changePage
                    }, null, 8, ["page", "total-pages"])
                ], 2)
            ], 64));
        };
    }
});
